var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content != null)?_c('content-form',{attrs:{"edit":true,"content":_vm.content}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }